<template>
  <div class="manual-payments">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" />
    <div class="filters">
      <div class="search">
        <div class="option">
          <span>Account</span>
          <a-select
            v-model:value="filters.email"
            show-search
            allowClear
            style="width: 200px"
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
            :options="options"
            @search="onSearch"
            @change="onSelect"
            :getPopupContainer="
              (triggerNode) => {
                return triggerNode.parentNode || document.body
              }
            "
          ></a-select>
        </div>
        <div class="option" ref="marketplaceRef">
          <span>Marketplace</span>
          <!-- <artmisads-input v-model:value="filters.marketplace" @press-enter="getPartData({})"
            placeholder="Enter Marketplace"></artmisads-input> -->
          <artmisads-select
            style="width: 232px"
            v-model:value="filters.marketplace"
            :getPopupContainer="() => marketplaceRef"
            :options="COUNTRY_BASE_OPTIONS"
            @change="onMarketplaceChange"
          />
        </div>

        <div class="option" ref="statusRef">
          <span>ASIN</span>
          <a-input
            v-model:value="filters.asin"
            placeholder="Enter ASIN"
          />
          
        </div>
      </div>
      <div class="button">
        <artmisads-button
          isSquare="true"
          type="primary"
          style="margin-right: 12px"
          :loading="load"
          @click="searchList"
          >Search</artmisads-button
        >
        <artmisads-button isSquare="true" @click="onReset"
          >Reset</artmisads-button
        >
      </div>
    </div>
    <div class="add">
      <artmisads-button isSquare="true" type="primary" @click="bulkUpdate">
        Bulk Update
      </artmisads-button>
      <artmisads-button isSquare="true" type="primary" @click="exportData">
        Export
      </artmisads-button>
      <artmisads-button
        isSquare="true"
        type="primary"
        @click="addManualPayment"
      >
        New
      </artmisads-button>
    </div>
    <div class="table-data">
      <artmisads-table
        v-model:pagination="pagination"
        :columns="columns"
        :data-source="dataList"
        :change="onTableChange"
        :loading="load"
        :scroll="{ x: 1800, y: tableScrollHeight }"
      >
        <template #bodyCell="{ record, index, column }">
          <template v-if="column.key === 'date'">
            {{ record.createdAt && moment(Number(record.createdAt)).tz(BILLING_TIME_TZ[record.marketplace]).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
          <template v-if="column.key === 'dateRange'">
            {{ record.beginTimeStr }} - {{ record.endTimeStr }}
          </template>
        </template>
      </artmisads-table>
    </div>
    <dealsInfoModel ref="modelRef" @refresh="getData({})" />
    <bulkUpdateModel ref="bulkUpdateModelRef" @refreshList="getData({})" />
  </div>
</template>

<script setup>
import { ref, reactive, onMounted,watch} from 'vue'
import breadcrumbs from '../breadcrumbs.vue'
import { COUNTRY_BASE } from '~/contants/common'
import { useTableScrollHeight } from '@/utils/useTableScrollHeight'
import bulkUpdateModel from './components/bulkUpdateModel.vue'
import dealsInfoModel from './components/dealsInfoModel.vue'
import { financeApi } from '~/server/operator/finance'
import moment from 'moment'
import { BILLING_TIME_TZ } from '~/contants/common';

import {  COUNTRY_SITE_CODE_MAP } from '~/contants/common'

const columns = [
  {
    title: 'Date',
    key: 'date',
    dataIndex: 'date',
    align: 'center',
  },
  {
    title: 'Marketplace',
    dataIndex: 'marketplace',
    key: 'marketplace',
    align: 'center',
  },
  {
    title: 'Account',
    dataIndex: 'sellerEmail',
    key: 'account',
    align: 'center',
  },
  {
    title: 'ASIN',
    dataIndex: 'asin',
    key: 'asin',
    align: 'center',
  },
  {
    title: 'AmazonSellerName',
    dataIndex: 'amazonName',
    key: 'amazonName',
    align: 'center',
  },
  {
    title: 'FullPrice',
    dataIndex: 'fullPrice',
    key: 'fullPrice',
    align: 'center',
  },
  {
    key: 'finalPrice',
    dataIndex: 'finalPrice',
    title: 'FinalPrice',
    align: 'center',
    key: 'finalPrice',
  },
  {
    title: 'DateRange',
    dataIndex: 'dateRange',
    key: 'dateRange',
    align: 'center',
  },
  {
    title: 'DealType',
    dataIndex: 'type',
    key: 'dealType',
    align: 'center',
  },
]
const options = ref([])
const userId=ref('')
const dataList = ref([])
const modelRef = ref(null)
const pagination = reactive({
  current: 1,
  defaultPageSize: 10,
  size: 10,
  pageSize: 10,
  total: 0,
  pageSizeOptions: ['10', '20', '50', '100'],
  showSizeChanger: true,
})
const marketplaceRef = ref(null)
const statusRef = ref(null)
const COUNTRY_BASE_OPTIONS = COUNTRY_BASE.map((item) => {
  item.value = item.host
  item.label = item.host
  return item
})
const { tableScrollHeight } = useTableScrollHeight({
  selector: '.table-data',
  bottomSpace: 280,
  minHeight: 200,
  maxHeight: 1000,
  defaultHeight: 350,
})
const load = ref(false)
const statusOptions = ref([
  {
    label: 'All',
    value: '',
  },
  {
    label: 'Paid',
    value: 'Paid',
  },
  {
    label: 'Unpaid',
    value: 'Unpaid',
  },
])
const breadcrumbsData = ref({
  title: 'DealsInfo',
  des: '',
  links: [
    {
      name: 'Home',
      path: '/operator/users',
    },
    {
      name: 'Operation',
      path: '/operator/operation/manualPayments',
    },
    {
      name: 'DealsInfo',
      path: '/operator/operation/dealsInfo',
    },
  ],
})
const filters = ref({
    marketplace: '',
    asin: '',
    email: '',
})
const userInfoArr = ref([])
const optionsAsin = ref([])
const onSearch = (e) => {
  const parma = {
    email: e,
  }
  getUser(parma)
}
const onSelect = (e) => {
  const res = userInfoArr.value.find((v) => v.userId == e)
  filters.value.email = res.email
  userId.value = res.userId

}
const getUser = async (parma) => {
  const res = await financeApi.getUserInfo(parma)
  let data = res.filter((v) => v.userType === 'seller')
  options.value = data.map((item) => ({
    label: item.email,
    value: item.userId,
  }))
  userInfoArr.value = data
}
const searchList=async () => {
 
  getData(filters.value)
}
// setTimeout(() => {
//   modelRef.value.show()
// }, 1000);
const bulkUpdateModelRef = ref(null)
const bulkUpdate = () => {
  bulkUpdateModelRef.value.open()
}
const exportData=()=>{
  const params={
    marketplace: filters.value.marketplace,
    asin: filters.value.asin,
    email: filters.value.email,
    page: pagination.current,
    size: pagination.size,
  }
  financeApi.productDealExport({
    qs: params,
    fileName: `deal_info_${moment().format('YYYY-MM-DD')}.xlsx`,
    platform:'operator'
  })
}
const addManualPayment = () => {
  modelRef.value.show()
}

const onReset = () => {
  filters.value = {
    marketplace: '',
    asin: '',
    email: '',
  }
  getData({})
}
const onTableChange = ({ current, pageSize }) => {
  pagination.current = current
  pagination.size = pageSize
  pagination.pageSize = pageSize
  getData({ page: current, size: pageSize })
}
const getData = async (params) => {
  load.value = true
  if (Object.keys(params).length === 0) {
    pagination.current = 1
  }
  let _params = {
    page: 1,
    size: pagination.size,
    // marketplace: filters.marketplace,
    // sellerId: filters.sellerId,
    // bd: filters.bd
  }
  let newparams = { ..._params, ...params }
  newparams = Object.keys(newparams).reduce((acc, key) => {
    if (
      newparams[key] !== null &&
      newparams[key] !== undefined &&
      newparams[key] !== ''
    ) {
      acc[key] = newparams[key]
    }
    return acc
  }, {})
  financeApi
    .getDealList(newparams)
    .then((res) => {
      
      if (res.success) {
        dataList.value = res.data.data
        pagination.total = res.data.total
      }
    })
    .finally(() => {
      load.value = false
    })
}

const edit = (record) => {
  console.log(record, 'record')
}
const view = (record) => {
  console.log(record, 'record')
}
const revoke = (record) => {
  console.log(record, 'record')
}
// getData({})
onMounted(() => {
  getData({})
})
// setTimeout(() => {
//   modelRef.value.show()
// }, 1000);
</script>
<style scoped lang="less">
.autoComplete {
  :deep(.ant-select-selector) {
    height: 32px !important;
  }
  :deep(.ant-select-selection-search-input) {
    height: 32px !important;
  }
  :deep(.ant-select-selection-placeholder) {
    line-height: 32px !important;
  }
}

.add {
  display: flex;
  justify-content: flex-end;
  margin: 16px 0;
  gap: 12px;
}
.manual-payments {
  padding: 16px;
  padding-top: unset;
  width: 100%;
}
.table-data {

  border-radius: 8px;
  border: 1px solid #fff;
  border-radius: 12px;
  overflow: hidden;
  border-radius: 12px;
  background-color: var(--color-white);
  padding: 15px;
  :deep(.ant-table) {
    border-radius: 8px 8px 0 0;
  }

  :deep(.ant-table-cell) {
    padding-left: 8px;
    padding-right: 8px;

    > a {
      color: var(--primary);

      &:hover {
        color: var(--primary-hover);
      }
    }
  }

  :deep(.ant-table-thead) {
    border-radius: 8px 8px 0 0;
  }

  .user {
    flex: 1;

    .user-name {
      color: var(--dark-1);
      font-weight: 500;
      font-size: 16px;
      letter-spacing: 0.4px;
      line-height: 20px;

      > span {
        font-weight: 400;
        margin-left: 4px;
      }
    }

    .user-email {
      font-weight: 500;
      font-size: 12px;
      color: var(--dark-2);
      letter-spacing: 0.3px;
      line-height: 16px;
      padding: 10px 0;
    }

    .user-id {
      height: 16px;
      font-weight: 500;
      font-size: 12px;
      color: var(--dark-3);
      letter-spacing: 0.3px;
      line-height: 16px;
    }
  }

}
.filters {
  display: flex;
  justify-content: space-between;

  .search {
    display: flex;

    .option {
      > span {
        margin-right: 8px;
      }

      display: flex;
      align-items: center;
      margin-right: 24px;
    }
  }
}
</style>
